<template>
	<div class="iv2-error-500">
		<h1 class="iv2-error-500-number">500</h1>
		<h2 class="iv2-error-500-lead">アクセスしようとしたページは表示できませんでした。</h2>
		<p class="iv2-error-500-summary">
			内部参照におけるエラーのため、
			<br class="br-pc" />目的のページが表示できなかったことを意味します。
		</p>
	</div>
</template>

<script>
export default {
	data() {
		return {
			name: "Error500"
		};
	}
};
</script>

<style lang="scss">
.iv2-error-500 {
	padding: 6rem 0;
	background-color: #efefef;
	height: 100vh;

	.iv2-error-500-number {
		text-align: center;
		padding: 7rem 2rem 0 2rem;
		font-size: 5.5rem;
	}

	.iv2-error-500-lead {
		text-align: center;
		font-size: 1.5rem;
		font-weight: 600;
		padding: 2rem 1rem;
		margin: 0;
	}

	.iv2-error-500-summary {
		text-align: center;
		padding: 0 1rem 2rem 1rem;
		margin: 0;
	}
}

@media (max-width: 1199px) {
	.iv2-error-500 {
		.iv2-error-500-lead {
			font-size: 1rem;
		}
	}
}
</style>